/** 站内 Instagram 工具页链接，用于内链与导航 */
export const INSTAGRAM_TOOL_LINKS = [
	{
		path: '/instagram-viewer/',
		label: 'Instagram Viewer',
	},
	{
		path: '/instagram-photo-downloader/',
		label: 'Instagram Photo Downloader',
	},
	{
		path: '/instagram-story-downloader/',
		label: 'Instagram Story Downloader',
	},
	{
		path: '/instagram-reels-downloader/',
		label: 'Instagram Reels Downloader',
	},
	{
		path: '/instagram-igtv-downloader/',
		label: 'Instagram IGTV Downloader',
	},
]

export function getRelatedTools (currentPath) {
	return INSTAGRAM_TOOL_LINKS.filter((item) => item.path !== currentPath)
}
